export default __webpack_public_path__ + "4a02289e196ccc3846a82e75280489f7.png";